"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CashOrderDetailContent from "./cashOrderDetailContent";

export default function CashOrderDetailView() {
  const navigate = useNavigate();
	const location = useLocation();
	const recieptno = location.state?.recieptno || null;

  return <CashOrderDetailContent navigate={navigate} recieptno={recieptno} />;
}
